import $ from 'jquery';
import 'jquery-validation';

(($) => {
    'use strict';

    const msfCssClasses = {
        header: 'msf-header',
        step: 'msf-step',
        statuses: {
            stepComplete: 'msf-step-complete',
            stepIncomplete: 'msf-step-incomplete',
            stepActive: 'msf-step-active',
        },
        content: 'msf-content',
        view: 'msf-view',
        navigation: 'msf-navigation',
        navButton: 'msf-nav-button',
    };

    const msfNavTypes = {
        back: 'back',
        next: 'next',
        submit: 'submit',
    };

    const msfJqueryData = {
        validated: 'msf-validated',
        visited: 'msf-visited',
    };

    const msfEventTypes = {
        viewChanged: 'msf:viewChanged',
    };

    $.fn.multiStepForm = function (options) {
        var form = this;

        var defaults = {
            activeIndex: 0,
            validate: {},
            hideBackButton: false,
            allowUnvalidatedStep: false,
            allowClickNavigation: false,
        };

        var settings = $.extend({}, defaults, options);

        //find the msf-content object
        form.content = this.find('.' + msfCssClasses.content).first();

        if (form.content.length === 0) {
            throw new Error("Multi-Step Form requires a child element of class '" + msfCssClasses.content + "'");
        }

        //find the msf-views within the content object
        form.views = $(this.content).find('.' + msfCssClasses.view);

        if (form.views.length === 0) {
            throw new Error(
                "Multi-Step Form's element of class '" +
                msfCssClasses.content +
                "' requires n elements of class '" +
                msfCssClasses.view +
                "'",
            );
        }

        form.currentIndex = 0;
        form.header = this.find('.' + msfCssClasses.header).first();
        form.navigation = this.find('.' + msfCssClasses.navigation).first();
        form.steps = [];
        //form.completedSteps = 0;

        form.getActiveView = function () {
            return form.views.filter(function (i, e) {
                return e.style && e.style.display !== 'none';
            });
        };

        form.setActiveView = function (index) {
            var previousView = form.getActiveView()[0];
            var previousIndex = form.views.index(previousView);
            var view = form.views.eq(index);

            if (view.hasClass('hide-step')) {
                var incrementing = previousIndex < index;
                form.setActiveView(incrementing ? index + 1 : index - 1);
                return;
            }

            $(previousView).hide();

            view.show();

            var completedSteps = 0;
            $.each(form.views, function (index, view) {
                if ($.data(view, msfJqueryData.validated)) {
                    completedSteps++;
                }
            });

            //trigger the 'view has changed' event
            form.trigger(msfEventTypes.viewChanged, {
                currentIndex: index,
                previousIndex: previousIndex,
                totalSteps: form.steps.length,
                completedSteps: completedSteps,
            });
        };

        form.setStatusCssClass = function (step, cssClass) {
            $(step).removeClass(msfCssClasses.statuses.stepComplete);
            $(step).removeClass(msfCssClasses.statuses.stepIncomplete);

            $(step).addClass(cssClass);
        };

        form.tryNavigateToView = function (currentIndex, targetIndex) {
            if (targetIndex <= currentIndex) {
                form.validateView(form.views[currentIndex], true);

                if (!settings.hideBackButton) form.setActiveView(targetIndex);
                return;
            }

            if (
                !form.validateViews(currentIndex, targetIndex - currentIndex, function (i) {
                    if (!settings.allowUnvalidatedStep) {
                        form.setActiveView(i);
                        return false;
                    }

                    return true;
                })
            ) {
                if (!settings.allowUnvalidatedStep) {
                    return;
                }
            }
            form.setActiveView(targetIndex);
        };

        form.init = function () {
            $('.form-control[required]', form).each(function () {
                const input = $(this);
                input.addClass('required');
                input.on('invalid', function () {
                    if (input.val() == '') {
                        this.setCustomValidity(`${input.siblings($('label').text())} is required`);
                    } else if (input.siblings('label').text().indexOf('?') != -1) {
                        this.setCustomValidity('This field is required');
                    } else if (input.attr('type') == 'tel') {
                        this.setCustomValidity('Please enter a valid number');
                    } else if (input.attr('name').toLowerCase() == 'zip') {
                        this.setCustomValidity('Please enter a valid zip code');
                    } else {
                        this.setCustomValidity('');
                    }
                });
            });

            this.initHeader = function () {
                if (form.header.length === 0) {
                    form.header = $('<div/>', {
                        class: msfCssClasses.header,
                        display: 'none',
                    });

                    $(form).prepend(form.header);
                }

                form.steps = $(form.header).find('.' + msfCssClasses.step);

                this.initStep = function (index, view) {
                    //append steps to header if they do not exist
                    if (form.steps.length < index + 1) {
                        $(form.header).append(
                            $('<div/>', {
                                class: msfCssClasses.step,
                                display: 'none',
                            }),
                        );
                    }

                    if (settings.allowClickNavigation) {
                        //bind the click event to the header step
                        $(form.steps[index]).click(function (e) {
                            var view = form.getActiveView()[0];
                            var currentIndex = form.views.index(view);
                            var targetIndex = form.steps.index($(e.target).closest('.' + msfCssClasses.step)[0]);

                            form.tryNavigateToView(currentIndex, targetIndex);
                        });
                    }
                };

                $.each(form.views, this.initStep);

                form.steps = $(form.header).find('.' + msfCssClasses.step);
            };

            this.initNavigation = function () {
                if (form.navigation.length === 0) {
                    form.navigation = $('<div/>', {
                        class: msfCssClasses.navigation,
                    });

                    $(form.content).after(form.navigation);
                }

                this.initNavButton = function (type) {
                    var element = this.navigation.find("button[data-type='" + type + "'], input[type='button']"),
                        type;
                    if (element.length === 0) {
                        element = $('<button/>', {
                            class: msfCssClasses.navButton,
                            'data-type': type,
                            type: type == msfNavTypes.submit ? 'submit' : 'button',
                            html: type,
                        });
                        element.appendTo(form.navigation);
                    }
                    return element;
                };

                form.backNavButton = this.initNavButton(msfNavTypes.back);
                form.nextNavButton = this.initNavButton(msfNavTypes.next);
                form.submitNavButton =
                    form.steps.length == 1
                        ? $('button[type=submit]', form.content)
                        : this.initNavButton(msfNavTypes.submit);
            };

            this.initHeader();
            this.initNavigation();

            this.views.each(function (index, view) {
                $.data(view, msfJqueryData.validated, false);
                $.data(view, msfJqueryData.visited, false);

                //if this is not the last view do not allow the enter key to submit the form as it is not completed yet
                if (index !== form.views.length - 1) {
                    $(view)
                        .find(':input')
                        .not('textarea')
                        .keypress(function (e) {
                            if (e.which === 13) {
                                // Enter key = keycode 13
                                form.nextNavButton.click();
                                return false;
                            }
                        });
                }

                $(view).on('show', function (e) {
                    if (this !== e.target) return;

                    var view = e.target;
                    $.data(view, msfJqueryData.visited, true);

                    var index = form.views.index(view);
                    form.currentIndex = index;
                    var step = form.steps[index];

                    $(step).addClass(msfCssClasses.statuses.stepActive);
                    //form.setStatusCssClass(step, msfCssClasses.statuses.stepActive);

                    //choose which navigation buttons should be displayed based on index of view
                    if (index > 0 && !settings.hideBackButton) {
                        form.backNavButton.show();
                    }

                    if (index == form.views.length - 1) {
                        form.nextNavButton.hide();
                        form.submitNavButton.show();
                    } else {
                        form.submitNavButton.hide();
                        form.nextNavButton.show();
                    }

                    // Make all required fields required again when they are shown
                    var hiddenInputs = $('.hidden-required', view);
                    hiddenInputs.each((i, e) => {
                        var element = $(e);
                        var parent = element.closest('.form-group');
                        if (parent.length == 0 || !parent.hasClass('hide')) {
                            element.removeClass('hidden-required');
                            element.attr('required', 'required');
                        }
                    });

                    const inputs = $(':input[required]');

                    inputs.each((i, el) => {
                        const formGroup = $(el).closest('.form-group');
                        if ($(el).siblings('label').text() == "*") {
                            var label = $(el).attr('placeholder') + ' is required';
                        } else {
                            var label = $(el).siblings('label').text() + ' is required';
                        }
                        label = label.replace('*', '');
                        let isSelect = $(el).is('select');
                        let isRadioOrCheckbox = $(el).attr('type') === 'radio' || $(el).attr('type') === 'checkbox';

                        if (isSelect || isRadioOrCheckbox || $(el).siblings('label').text().indexOf('?') != -1) {
                            label = 'This field is required';
                        } else if ($(el).attr('type') === 'tel') {
                            label = 'Please enter a valid number';
                        } else if ($(el).attr('type') === 'email') {
                            label = 'Please enter a valid email';
                        } else if ($(el).attr('name').toLowerCase() == 'zip') {
                            label = 'Please enter a valid zip code';
                        }

                        if (formGroup.find('.required-message').length === 0) {
                            formGroup.append(`
                                <div class='required-message'>
                                    <div class='inner'>
                                        <svg 
                                            aria-hidden="true" 
                                            focusable="false" 
                                            data-prefix="fas" 
                                            data-icon="exclamation-circle" 
                                            class="svg-inline--fa fa-exclamation-circle fa-w-16"
                                             role="img" xmlns="http://www.w3.org/2000/svg" 
                                             viewBox="0 0 512 512"
                                        >
                                            <path 
                                                fill="currentColor" 
                                                d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path>
                                        </svg>
                                        <span class='notification-text'>${label}</span>
                                    </div>
                                </div>
                            `);
                        }

                        if (!isSelect && !isRadioOrCheckbox) {
                            formGroup.find('.required-message').addClass('inline');
                        }

                        $(el).on('change', function () {
                            checkIfValid($(this));
                        });
                    });
                });

                $(view).on('hide', function (e) {
                    if (this !== e.target) return;

                    var index = form.views.index(e.target);
                    var step = form.steps[index];

                    $(step).removeClass(msfCssClasses.statuses.stepActive);

                    if ($.data(e.target, msfJqueryData.validated) && $.data(e.target, msfJqueryData.visited)) {
                        form.setStatusCssClass(step, msfCssClasses.statuses.stepComplete);
                    } else if ($.data(e.target, msfJqueryData.visited)) {
                        form.setStatusCssClass(step, msfCssClasses.statuses.stepIncomplete);
                    } else {
                        form.setStatusCssClass(step, '');
                    }

                    // Remove required from hidden fields
                    var hiddenInputs = $(':input[required="required"]', view);
                    hiddenInputs.addClass('hidden-required');
                    hiddenInputs.removeAttr('required');

                    //hide all navigation buttons, display choices will be set on show event
                    form.backNavButton.hide();
                    form.nextNavButton.hide();
                    form.submitNavButton.hide();
                });

                //initially hide each view
                $(view).hide();
            });

            if (settings.activeIndex > 0) {
                $(form).ready(function () {
                    form.tryNavigateToView(0, settings.activeIndex);
                });
            } else {
                form.setActiveView(0);
            }
        };

        form.validateView = function (view, showAll = false) {
            let valid = true;
            let values = [];

            $(':input[required]', view).each((i, element) => {
                if (showAll) {
                    values.push(checkIfValid(element));
                } else {
                    let check = checkIfValid(element);
                    if (!check) return (valid = false);
                }
            });
            if (values.includes(false)) valid = false;

            return valid;
        };

        form.validateViews = function (currentIndex, length, invalid) {
            currentIndex = typeof currentIndex === 'undefined' ? 0 : currentIndex;
            length = typeof length === 'undefined' ? form.views.length : length;
            var isValid = true;

            for (var i = currentIndex; i < currentIndex + length; i++) {
                if (!form.validateView(form.views[i], true)) {
                    isValid = false;
                    if (!invalid(i)) {
                        break;
                    }
                }
            }

            return isValid;
        };

        form.init();

        form.nextNavButton.click(function () {
            var view = form.getActiveView()[0];
            var index = form.views.index(view);

            if (form.validateView(view, true)) {
                form.setActiveView(index + 1);
            } else if (settings.allowUnvalidatedStep) {
                form.setActiveView(index + 1);
            }
        });

        form.backNavButton.click(function () {
            var view = form.getActiveView()[0];
            var index = form.views.index(view);
            form.setActiveView(index - 1);
        });

        form.submitNavButton.click(function (e) {
            var view = form.getActiveView()[0];
            let valid = form.validateView(view, true);

            if (!valid) {
                e.preventDefault();
            }
        });

        return form;
    };

    $.validator.prototype.subset = function (container) {
        var ok = true;
        var self = this;
        $(container)
            .find(':input')
            .each(function () {
                if (!self.element($(this))) ok = false;
            });
        return ok;
    };

    $.each(['show', 'hide'], function (i, ev) {
        var el = $.fn[ev];
        $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
        };
    });

    function checkIfValid(element) {
        let valid = true;
        let val = $(element).val();
        let type = $(element).attr('type');
        var name = $(element).attr('name');

        const telTest = new RegExp('^(\\+?1[ -]?)?\\(?[2-9]\\d\\d\\)?[ -]?[2-9]\\d\\d[ -]?\\d{4}$');
        const emailTest = new RegExp(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
        const zipTest = new RegExp('^\\d{5}(?:[-\\s]\\d{4})?$');

        if (type === 'tel') {
            if (val) {
                telTest.test(val) ? (valid = true) : (valid = false);
            } else {
                valid = false;
            }
        } else if (type === 'email') {
            if (val) {
                emailTest.test(val) ? (valid = true) : (valid = false);
            } else {
                valid = false;
            }
        } else if (name.toLowerCase() === 'zip') {
            if (val) {
                zipTest.test(val) ? (valid = true) : (valid = false);
            } else {
                valid = false;
            }
        } else if (type === 'radio' || type === 'checkbox') {
            let name = $(element).attr('name');
            let siblings = $(`:input[name="${name}"]`);
            let vals = [];

            siblings.each((i, el) => {
                if (!$(el).is(':checked')) {
                    vals.push(false);
                } else {
                    vals.push(true);
                }
            });

            vals.includes(true) ? (valid = true) : (valid = false);
        } else {
            if (val != null) {
                if ($(element).is('select')) {
                    $(element).attr('value', val);
                    if ($(element).attr('value') == undefined) {
                        valid = false;
                    }
                } else {
                    val = val.replace(/^\s+/, '').replace(/\s+$/, '');
                    val !== '' ? (valid = true) : (valid = false);
                }
            } else {
                valid = false;
            }
        }

        if (!valid) {
            if (!$(element).hasClass('invalid')) {
                $(element).addClass('invalid');
                $(element).closest('.form-group').find('.required-message').addClass('appear');
            } else {
                $(element).closest('.form-group').find('.required-message').addClass('appear');
            }
        } else if (valid) {
            if (type === 'radio' || type === 'checkbox') {
                let name = $(element).attr('name');
                let siblings = $(`:input[name="${name}"]`);

                $(element).removeClass('invalid');

                siblings.each((i, el) => {
                    if ($(el).hasClass('invalid')) {
                        $(el).removeClass('invalid');
                    }
                });
                $(element).parents('.radio-group').siblings('.required-message').removeClass('appear');
            } else {
                $(element).removeClass('invalid');
                $(element).siblings('.required-message').removeClass('appear');
            }
        }

        return valid;
    }
})($);
